import React from "react";
import { ColumnType } from "antd/lib/table";
import { BundleProduct } from "@/Contracts/Products";
import { BundledProductRowFormNameLabel } from "@/Components/DocumentsPage/Drawers/DocumentProductDrawers/DocumentProductDrawersComponents/BundledProductRowFormNameLabel/BundledProductRowFormNameLabel";
import { PricingNameInput } from "@/Components/DocumentsPage/Drawers/DocumentProductDrawers/DocumentProductDrawersComponents/BundleProductDrawerTable/BundleProductDrawerTable";
import { BundledProductRowFormOptions } from "@/Components/DocumentsPage/Drawers/DocumentProductDrawers/DocumentProductDrawersComponents/BundledProductRowFormOptions";
import { IBundledProductTableColumnsProps } from "./interface";
import { Row, Col } from "antd";
import { ZInputNumber } from "@atoms";
import { InputNumberWidths } from "@atoms/ZInputNumber";
import { getCurrencySettings } from "@/Utils/Currency";

export default ({
	handlePricingChange,
	handleBundledProductSetupPriceChange,
	handleBundledProductCostPriceChange,
	handleBundledProductSellPriceChange,
	handleBundledProductQuantityChange,
	handleBundleProductChildDelete,
	handleEditDrawerOpen,
	toggleBundleProductOptional,
	isReadonly
}: IBundledProductTableColumnsProps): ColumnType<BundleProduct>[] => [
	{
		title: "Product name",
		dataIndex: "name",
		key: "name",
		className: "drag-visible-z-table-row",
		width: 300,
		render: (_text: unknown, product: BundleProduct) => {
			const { selected_setup_price, item, selected_pricing_id, item_id } =
				product;
			return (
				<BundledProductRowFormNameLabel
					product={{ ...product, name: product.name || item.name }}
				>
					<PricingNameInput
						pricingArray={item.pricing}
						selectedPricingId={selected_pricing_id}
						onChange={handlePricingChange(item_id)}
					/>
					<Row className="mt-3 items-center">
						<Col span={7}>
							<span>Setup Fee:</span>
						</Col>
						<Col offset={1} span={9}>
							<ZInputNumber
								addOnAfter={getCurrencySettings().currency}
								disabled={isReadonly}
								defaultValue={selected_setup_price || 0}
								min={0}
								max={99999999999}
								onChange={handleBundledProductSetupPriceChange(
									item_id
								)}
								width={InputNumberWidths.full}
							/>
						</Col>
					</Row>
				</BundledProductRowFormNameLabel>
			);
		}
	},
	{
		title: "Cost Price",
		dataIndex: "selected_cost_price",
		key: "selected_cost_price",
		width: 150,
		className: "drag-visible-z-table-row",
		render: (selected_cost_price: number, product: BundleProduct) => (
			<div>
				<ZInputNumber
					addOnAfter={getCurrencySettings().currency}
					disabled={isReadonly}
					defaultValue={selected_cost_price}
					min={0}
					max={99999999999}
					onChange={handleBundledProductCostPriceChange(
						product.item_id
					)}
					width={InputNumberWidths.full}
				/>
			</div>
		)
	},
	{
		title: "Selling Price",
		dataIndex: "sell_price",
		key: "sell_price",
		width: 150,
		className: "drag-visible-z-table-row",
		render: (sell_price: number, product: BundleProduct) => (
			<div>
				<ZInputNumber
					addOnAfter={getCurrencySettings().currency}
					disabled={isReadonly}
					defaultValue={sell_price}
					min={0}
					max={99999999999}
					onChange={handleBundledProductSellPriceChange(
						product.item_id
					)}
					width={InputNumberWidths.full}
				/>
			</div>
		)
	},
	{
		title: "Quantity",
		dataIndex: "quantity",
		key: "quantity",
		width: 80,
		className: "drag-visible-z-table-row",
		render: (quantity: number, product: BundleProduct) => (
			<div>
				<ZInputNumber
					disabled={isReadonly}
					defaultValue={quantity}
					min={1}
					max={99999999999}
					onChange={handleBundledProductQuantityChange(
						product.item_id
					)}
					width={InputNumberWidths.full}
				/>
			</div>
		)
	},
	{
		title: "",
		dataIndex: "name",
		key: "options",
		width: 30,
		className: "drag-visible-z-table-row",
		render: (_name: string, product: BundleProduct) => (
			<div>
				<BundledProductRowFormOptions
					isReadonly={isReadonly}
					deleteBundleProductChild={handleBundleProductChildDelete(
						product.item_id
					)}
					onEditDrawerOpen={handleEditDrawerOpen({
						...product,
						name: product.name || product.item.name
					})}
					toggleBundleProductOptional={toggleBundleProductOptional(
						product
					)}
					isOptional={product.is_optional ?? false}
				/>
			</div>
		)
	}
];
